import React, { useState } from "react";
import "./Admin.css";
import axios from "axios";
import Footer from "../Footer1/Footer1";

export default function Admin() {

  const API_URL = "https://news-1-wyad.onrender.com/api/news";

  const [photo, setPhoto] = useState(null);
  const [video, setVideo] = useState(null);

  const [photoPreview, setPhotoPreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);

  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");

  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  /* ---------------- IMAGE RESIZE SAFE VERSION ---------------- */
  const resizeImage = (file) =>
    new Promise((resolve) => {

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (event) => {

        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {

          const canvas = document.createElement("canvas");

          const MAX_WIDTH = 900;
          const scale = MAX_WIDTH / img.width;

          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scale;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => resolve(blob),
            "image/jpeg",
            0.7
          );
        };
      };
    });

  /* ---------------- PICKERS ---------------- */
  const openPhotoPicker = () => document.getElementById("photoInput").click();
  const openVideoPicker = () => document.getElementById("videoInput").click();

  /* ---------------- PHOTO CHANGE ---------------- */
  const handlePhotoChange = async (e) => {

    const file = e.target.files[0];
    if (!file) return;

    /* ⭐ 20MB LIMIT */
    if (file.size > 20 * 1024 * 1024) {
      alert("File size must be less than 20MB");
      return;
    }

    setUploading(true);

    const compressed = await resizeImage(file);

    setPhoto(compressed);
    setPhotoPreview(URL.createObjectURL(compressed));

    setUploading(false);
  };

  /* ---------------- VIDEO CHANGE ---------------- */
  const handleVideoChange = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 20 * 1024 * 1024) {
      alert("Video size must be less than 20MB");
      return;
    }

    setVideo(file);
    setVideoPreview(URL.createObjectURL(file));
  };

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!photo && !video) {
      alert("Please upload photo or video!");
      return;
    }

    const formData = new FormData();

    if (photo) formData.append("photo", photo);
    if (video) formData.append("video", video);

    formData.append("title", title);
    formData.append("date", date);

    try {

      setUploading(true);
      setProgress(0);

      const res = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },

        onUploadProgress: (e) => {

          const percent = e.total
            ? Math.round((e.loaded * 100) / e.total)
            : 0;

          setProgress(percent);
        }
      });

      alert(res.data.message || "Upload Success ✅");

      /* RESET */
      if (photoPreview) URL.revokeObjectURL(photoPreview);
      if (videoPreview) URL.revokeObjectURL(videoPreview);

      setPhoto(null);
      setVideo(null);
      setPhotoPreview(null);
      setVideoPreview(null);
      setTitle("");
      setDate("");

    } catch (err) {

      console.error(err);
      alert("Upload Failed ❌");

    } finally {

      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <>
      <div className="upload-container">
        <h2>Add Photos / Videos</h2>

        {/* PHOTO UPLOAD */}
        <div className="upload-box" onClick={openPhotoPicker}>
          {photoPreview ? (
            <img src={photoPreview} alt="preview" className="preview-img" />
          ) : (
            <>
              <i className="fa-solid fa-camera camera-icon"></i>
              <p>Upload Photo</p>
            </>
          )}
        </div>

        <input
          type="file"
          id="photoInput"
          hidden
          accept="image/*"
          onChange={handlePhotoChange}
        />

        {/* VIDEO UPLOAD */}
        <div className="upload-box1" onClick={openVideoPicker}>
          {videoPreview ? (
            <video src={videoPreview} controls className="preview-video" />
          ) : (
            <>
              <i className="fa-solid fa-video camera-icon"></i>
              <p>Upload Video</p>
            </>
          )}
        </div>

        <input
          type="file"
          id="videoInput"
          hidden
          accept="video/*"
          onChange={handleVideoChange}
        />

        {/* FORM */}
        <form onSubmit={handleSubmit} className="form-box">

          <input
            type="text"
            placeholder="Enter Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />

          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />

          <button type="submit" disabled={uploading}>
            {uploading ? "Uploading..." : "Submit"}
          </button>

        </form>

        {/* LOADER */}
        {uploading && (
          <div className="upload-loader">
            <p>Uploading... {progress}% ⏳</p>
          </div>
        )}

      </div>

      <Footer />
    </>
  );
}